








































































import {Component, Vue, Prop} from 'vue-property-decorator';
import CampaignArticleList from '@/modules/campaignArticles/_components/CampaignArticleList.vue';
import CampaignPreview from '@/modules/campaigns/_components/CampaignPreview.vue';
import { Action, Getter } from 'vuex-class';
import Card from '@/components/material/Card.vue';
import DlgCampaignTest from '@/modules/campaigns/_components/DlgCampaignTest.vue';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    DlgCampaignTest,
    Card,
    CampaignPreview,
    CampaignArticleList,
  },
})
export default class AdsList extends Vue {
  public $refs!: {
    previewComponent: any,
  };
  @Prop(String) private readonly id!: string;

  @Action('campaigns/readOne') private readOne!: any;
  @Action('campaigns/update') private update!: any;

  @Getter('campaigns/one') private campaign: any;
  @Getter('rules/all') private rules!: any;

  private localCampaign: any = {};
  private loading: boolean = false;
  private isAdmin: boolean = false;

  private async mounted() {
    await this.refresh();

    const currentUserInfo = await Auth.currentUserInfo();
    this.isAdmin = currentUserInfo.username === 'slaat';
  }

  private async refresh() {
    this.loading = true;
    await this.readOne({id: this.id});
    this.localCampaign = JSON.parse(JSON.stringify(this.campaign));
    this.loading = false;
  }

  private refreshPreview() {
    this.$refs.previewComponent.refresh();
  }

  private async updateCampaign() {
    this.loading = true;
    await this.update(this.localCampaign);
    await this.refresh();
    this.loading = false;
  }
}
